import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.applications');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-applications',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportApplicationsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public programs: any[] = [];
    public announcements: any[] = [];
    public loaded: boolean = false;

    public page: number = 1;
    public lastpage: number = 1;
    public total: number = 0;
    public programFilter: string = '';
    public announcementFilter: string = '';
    public statusFilter: string = '';
    public searchText: string = '';

    public appStatusMap: any = {
        submitted: { label: '접수', cls: 'bg-blue-50 text-blue-700' },
        screening: { label: '심사중', cls: 'bg-amber-50 text-amber-700' },
        doc_passed: { label: '서류통과', cls: 'bg-emerald-50 text-emerald-700' },
        doc_failed: { label: '서류탈락', cls: 'bg-red-50 text-red-700' },
        pt_passed: { label: '발표통과', cls: 'bg-emerald-100 text-emerald-800' },
        pt_failed: { label: '발표탈락', cls: 'bg-red-100 text-red-800' },
        selected: { label: '최종선정', cls: 'bg-emerald-600 text-white' },
        rejected: { label: '최종탈락', cls: 'bg-zinc-500 text-white' },
        withdrawn: { label: '철회', cls: 'bg-zinc-100 text-zinc-500' },
    };

    public async ngOnInit() {
        await this.service.init();
        // URL query 에서 필터 값 (announcement_id) 자동 주입
        try {
            const sp = new URLSearchParams(window.location.search);
            const aid = sp.get('announcement_id');
            const pid = sp.get('program_id');
            if (aid) this.announcementFilter = aid;
            if (pid) this.programFilter = pid;
        } catch (e) { }
        await this.loadPrograms();
        await this.loadAnnouncements();
        await this.load();
    }

    public async loadPrograms() {
        const { code, data } = await wiz.call('programs');
        if (code == 200) this.programs = data.rows || [];
    }

    public async loadAnnouncements() {
        const { code, data } = await wiz.call('announcements', { program_id: this.programFilter });
        if (code == 200) this.announcements = data.rows || [];
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call('search', {
            page: this.page,
            program_id: this.programFilter,
            announcement_id: this.announcementFilter,
            status: this.statusFilter,
            text: this.searchText,
        });
        if (code == 200) {
            const rawRows = data.rows || [];
            this.items = this.groupApplicationRows(rawRows);
            this.lastpage = data.lastpage || 1;
            const duplicateReduction = Math.max(0, rawRows.length - this.items.length);
            this.total = Math.max(this.items.length, (data.total || this.items.length) - duplicateReduction);
        }
        this.loaded = true;
        await this.service.render();
    }

    public async onProgramChange() {
        this.announcementFilter = '';
        this.page = 1;
        await this.loadAnnouncements();
        await this.load();
    }

    public async setPage(p: number) {
        if (p < 1 || p > this.lastpage) return;
        this.page = p;
        await this.load();
    }

    public statusInfo(s: string) {
        return this.appStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    public formatMoney(n: any): string { return (Number(n) || 0).toLocaleString(); }

    public applicationRows(item: any): any[] {
        return Array.isArray(item?.applications) && item.applications.length ? item.applications : [item];
    }

    public dateText(v: any): string {
        if (!v) return '-';
        return String(v).slice(0, 19);
    }

    private groupApplicationRows(rows: any[]): any[] {
        const groups: any[] = [];
        const keyMap = new Map<string, any>();
        for (const row of rows || []) {
            const apps = this.applicationRows(row);
            const keys = this.companyGroupKeys(row, apps);
            const matched: any[] = [];
            for (const key of keys) {
                const group = keyMap.get(key);
                if (group && !matched.includes(group)) matched.push(group);
            }
            let group = matched[0];
            if (!group) {
                group = {
                    ...row,
                    applications: [],
                    application_count: 0,
                    is_invested: !!row.is_invested
                };
                groups.push(group);
            }
            for (const other of matched.slice(1)) {
                if (other === group) continue;
                for (const app of other.applications || []) {
                    if (!group.applications.some((x: any) => x.id === app.id)) group.applications.push(app);
                }
                group.is_invested = !!(group.is_invested || other.is_invested);
                if (!group.registed_number && other.registed_number) group.registed_number = other.registed_number;
                if (!group.company_id && other.company_id) group.company_id = other.company_id;
                const index = groups.indexOf(other);
                if (index >= 0) groups.splice(index, 1);
                for (const [key, mapped] of Array.from(keyMap.entries())) {
                    if (mapped === other) keyMap.set(key, group);
                }
            }
            for (const key of keys) keyMap.set(key, group);
            group.is_invested = !!(group.is_invested || row.is_invested);
            if (!group.registed_number && row.registed_number) group.registed_number = row.registed_number;
            if (!group.company_id && row.company_id) group.company_id = row.company_id;
            for (const app of apps) {
                if (!group.applications.some((x: any) => x.id === app.id)) {
                    group.applications.push(app);
                }
            }
        }
        const result = groups;
        for (const group of result) {
            group.applications.sort((a: any, b: any) => String(b.submitted_at || b.created || '').localeCompare(String(a.submitted_at || a.created || '')));
            const latest = group.applications[0] || group;
            group.id = latest.id || group.id;
            group.program_title = latest.program_title || group.program_title;
            group.announcement = latest.announcement || group.announcement;
            group.announcement_title = latest.announcement_title || group.announcement_title;
            group.score_total = latest.score_total ?? group.score_total;
            group.rank = latest.rank ?? group.rank;
            group.status = latest.status || group.status;
            group.submitted_at = latest.submitted_at || group.submitted_at;
            group.application_count = group.applications.length;
        }
        return result;
    }

    private companyGroupKeys(row: any, apps: any[]): string[] {
        const keys: string[] = [];
        const add = (key: string) => {
            if (key && !keys.includes(key)) keys.push(key);
        };
        for (const source of [row, ...(apps || [])]) {
            if (!source) continue;
            if (source.company_id) add(`company:${source.company_id}`);
            const reg = this.onlyDigits(source.registed_number);
            if (reg) add(`reg:${reg}`);
            const name = this.normalizeCompanyName(source.company_name);
            if (name) add(`name:${name}`);
            const email = String(source.ceo_email || source.manager_email || '').trim().toLowerCase();
            if (email) add(`email:${email}`);
        }
        if (keys.length === 0) add(`id:${row?.id || ''}`);
        return keys;
    }

    private onlyDigits(value: any): string {
        return String(value || '').replace(/\D/g, '');
    }

    private normalizeCompanyName(value: any): string {
        const name = String(value || '')
            .trim()
            .toLowerCase()
            .replace(/주식회사|유한회사|유한책임회사|\(주\)|㈜|\(유\)/g, '');
        return Array.from(name).filter((ch) => /[a-z0-9가-힣]/.test(ch)).join('');
    }

    public goDetail(item: any) {
        this.service.href(`/admin/support/applications/${item.id}`);
    }

    public exportCsv() {
        const params = new URLSearchParams({
            program_id: this.programFilter,
            announcement_id: this.announcementFilter,
            status: this.statusFilter,
            text: this.searchText,
        });
        window.open(`/wiz/api/portal.lpsysadmin.support.applications/export?${params.toString()}`, '_blank');
    }
}

export default PortalLpsysadminSupportApplicationsComponent;